import EquivalenceItem from '~/components/ui/EquivalenceItem';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
export default defineComponent({
  name: 'BlockEquivalence',
  components: {
    EquivalenceItem: EquivalenceItem
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    note: {
      type: String,
      default: ''
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    return {
      classes: classes
    };
  }
});